<template>
  <div>
    <el-table ref="multipleTable" :data="dataList" border tooltip-effect="dark" height="100%" style="width: 100%;" @row-click="clickFn" @row-dblclick="dblclickFn" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" align="center" prop="index" width="60"></el-table-column>
      <el-table-column label="状态" align="center" prop="state">
        <template slot-scope="scope">
          <el-tag :type="stateType[scope.row.state]">{{state[scope.row.state]}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="任务名称" align="center" prop="taskName"></el-table-column>
      <el-table-column label="任务类型" align="center" prop="taskType">
        <template slot-scope="scope">
          <el-tag type="">{{scope.row.taskType}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="执行类" align="center" prop="runClass"></el-table-column>
      <el-table-column label="定时时间" align="center" prop="taskTimer"></el-table-column>
      <el-table-column label="任务描述" align="center" prop="remark"></el-table-column>
      <el-table-column label="创建时间" align="center" prop="createDate">
        <template slot-scope="scope">
          {{scope.row.createDate|date}}
        </template>
      </el-table-column>
      <el-table-column label="用户名" align="center" prop="userName"></el-table-column>
      <el-table-column label="机构名称" align="center" prop="depName"></el-table-column>
      <el-table-column label="机构编号" align="center" prop="depCode"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import TableRowClick from '@/mixins/tableRowClick.mixin';

const state = {
  '-1': '停用',
  1: '启用'
};
const stateType = {
  '-1': 'danger',
  1: 'success'
};
export default {
  name: 'list',
  props: {
    dataList: {
      Array,
      default: []
    }
  },
  mixins: [TableRowClick],
  data() {
    return {
      state,
      stateType
    };
  },
  methods: {
    handleSelectionChange(selectArrys) {
      for (let i = 0; i < this.dataList.length; i++) {
        let item = this.dataList[i];
        item.checked = false;
      }
      for (let i = 0; i < selectArrys.length; i++) {
        selectArrys[i].checked = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
